import LoadingTablesIndex from './LoadingTablesIndex';
import LoadingTablesCreate from './LoadingTablesCreate';
import LoadingTablesSettings from './LoadingTablesSettings';
import LoadingTablesSingle from './LoadingTablesSingle';

export default function (app) {

    const settings = LoadingTablesSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Precise",
                path: settings.path + '/type/precise',
                caps: settings.indexCaps
            },
            {
                label: "General",
                path: settings.path + '/type/general',
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            }
        ],
    });

    LoadingTablesIndex(app, settings);

    LoadingTablesCreate(app, settings);

    LoadingTablesSingle(app, settings);

}